import { useQuery } from '@tanstack/react-query';
import { ContactData } from '@types';
import { fetchWithToken } from '@utils';
import * as Sentry from '@sentry/react';

interface UserDetailsResponse {
  isLoggedInUser: boolean;
  contactData: ContactData | null;
}

const fetchUserDetails = async (id: string): Promise<UserDetailsResponse> => {
  const CRM_CONTACT_ID = id;
  if (CRM_CONTACT_ID === null || CRM_CONTACT_ID === '') {
    return { isLoggedInUser: false, contactData: null };
  }
  const endPoint = `${
    import.meta.env.VITE_APIM_BASE_URL +
    '/wcc-dynamics/contacts(' +
    CRM_CONTACT_ID +
    ')'
  }`;
  try {
    const response: Response = await fetchWithToken(endPoint, {
      method: 'GET',
      headers: {
        'Cache-Control': 'no-cache',
        'wcc-apim-subscription-key': import.meta.env.VITE_APIM_API_KEY,
      },
    });
    const contactData = (await response.json()) as ContactData;
    return {
      isLoggedInUser: true,
      contactData,
    };
  } catch (error) {
    Sentry.captureException(error);
    throw new Error(error as string);
  }
};

export const useUserData = (crmId: string) => {
  const { data, error, isError, isLoading, isFetching } = useQuery({
    queryKey: ['userDetails', crmId],
    queryFn: async () => await fetchUserDetails(crmId),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });
  return {
    ...data,
    error,
    isError,
    isLoading,
    isFetching,
  };
};
